<ng-container *limitUp="DEVICE_SIZE.DESKTOP">
  <ul class="auxiliary-links">
    <li *ngFor="let link of availableLinks$ | async">
      <cx-link [link]="link" styleClass="link-hover-underline"></cx-link>
    </li>
  </ul>
</ng-container>

<ng-container *smallerThan="DEVICE_SIZE.DESKTOP">
  <abstract-lines [menu]="(availableLinks$ | async) ?? []"></abstract-lines>
</ng-container>
